import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetCrecaTradesRequestModel, GetCrecaTradesResponseModel } from "@/features/accounts/creca/services/get-trades-model";

export class GetCrecaTradesApi {
  /**
   * クレカ明細取得API
   */
  public getCrecaTrades = async (
    param: GetCrecaTradesRequestModel
  ): Promise<GetCrecaTradesResponseModel> => {
    const path = `/api/crecaaccounts/crecas/trades`;
    const res = await ApiClient.instance.get<GetCrecaTradesResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
